import { render, staticRenderFns } from "./register-mradio.vue?vue&type=template&id=36a32a1e&scoped=true&"
import script from "./register-mradio.vue?vue&type=script&lang=js&"
export * from "./register-mradio.vue?vue&type=script&lang=js&"
import style0 from "./register-mradio.vue?vue&type=style&index=0&id=36a32a1e&lang=scss&scoped=scoped&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36a32a1e",
  null
  
)

export default component.exports